import i18n from '../../i18n'
import NoExistingRewardLinkView from '../../views/NoExistingRewardLinkView'
import FAQ from '../../components/footer/FAQ'
import ContactUs from '../../components/footer/ContactUs'
import TermsOfService from '../../components/footer/TermsOfService'
import Survey from '@/components/Survey'
import { getNonExistingRouteNameEquivalent } from './utilities'
import { SURVEY_ROUTE, DEFAULT_ROUTE } from '@/router/routes/route-names'

const noExistingRewardLinkRoutes = [
  {
    path: '',
    component: NoExistingRewardLinkView,
    meta: {
      h1: i18n.t('faq-title'),
      h2: i18n.t('faq-subtitle'),
      h2Hidden: false
    },
    children: [
      {
        path: '',
        name: getNonExistingRouteNameEquivalent({ name: DEFAULT_ROUTE }),
        redirect: 'redeem',
        meta: {
          segmentName: 'Printed Reward Link Redemption Page'
        }
      },
      {
        // Redirect to external knowledge base in case of bookmark, manual url entry, etc.
        beforeEnter () {
          window.location = process.env.VUE_APP_KNOWLEDGE_BASE_URL
        },
        path: 'faq',
        name: getNonExistingRouteNameEquivalent({ name: 'FAQ' }),
        component: FAQ,
        meta: {
          h1: i18n.t('faq-title'),
          h2: i18n.t('faq-subtitle'),
          h2Hidden: false,
          segmentName: 'Frequently Asked Questions'
        }
      },
      {
        // Redirect to external knowledge base in case of bookmark, manual url entry, etc.
        beforeEnter () {
          window.location = process.env.VUE_APP_KNOWLEDGE_BASE_URL
        },
        path: 'contact-us',
        name: getNonExistingRouteNameEquivalent({ name: 'ContactUs' }),
        component: ContactUs,
        meta: {
          h1: i18n.t('contact-us-title'),
          h2: '',
          h2Hidden: true,
          segmentName: 'Contact Us'
        }
      },
      {
        path: 'terms-of-service',
        name: getNonExistingRouteNameEquivalent({ name: 'TermsOfService' }),
        component: TermsOfService,
        meta: {
          h1: i18n.t('terms-of-service-title'),
          h2: '',
          h2Hidden: true,
          segmentName: 'Terms of Service'
        }
      },
      {
        path: 'survey/:widgetId/:referenceOrderID',
        name: getNonExistingRouteNameEquivalent({ name: SURVEY_ROUTE }),
        component: Survey,
        props: true,
        meta: {
          h1: i18n.t('survey-title'),
          h2: i18n.t('survey-subtitle'),
          h2Hidden: false,
          segmentName: 'Survey'
        }
      }
    ]
  }
]

export { noExistingRewardLinkRoutes }
